import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';

import {
    BogIndicatorLegsInBet,
    LegPrice,
    NameInfoWrapper,
    NameWrapper,
} from 'src/domains/sportsbook/betting/bettingTab/cashout/selection/selectionNew/legsInBet/LegName.style';
import { useCommon } from 'src/domains/common/Common';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { MarketId } from 'src_common/common/websocket2/id/WebsocketId';

interface LegNamePropsType {
    dataTest?: string;
    isSettled: boolean;
    isShowBogIndicator: boolean;
    price: string | null;
    marketId: MarketId | null;
    resultStatus: string | undefined;
    selectionId: number | null;
    selectionName: string;
}

export const LegName = observer(
    'LegName',
    ({
        dataTest,
        isSettled,
        isShowBogIndicator,
        price,
        marketId,
        resultStatus,
        selectionId,
        selectionName,
    }: LegNamePropsType) => {
        const common = useCommon();
        const languagesState = LanguagesState.get(common);

        return (
            <NameWrapper>
                <NameInfoWrapper
                    isSettled={isSettled}
                    status={resultStatus}
                    data-test={dataTest}
                >
                    {languagesState.showSelectionTranslation(marketId, selectionId, selectionName)}

                    {isShowBogIndicator ? (
                        <BogIndicatorLegsInBet
                            size='small'
                            variant='primary'
                            label={
                                <I18n
                                    langKey='events.bog'
                                    defaultText='BOG'
                                />
                            }
                            dataTest='bog-indicator-bet'
                        />
                    ) : null}
                </NameInfoWrapper>

                {price === null ? null : <LegPrice data-test='leg-price'>{price}</LegPrice>}
            </NameWrapper>
        );
    }
);
